import { Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { ENVIRONMENT } from '@assethub/shared/models';
import { FirmwareState } from '@assethub/shared/models/firmware-state';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { TooltipComponent } from '../tooltip/tooltip.component';
import { CommonModule } from '@angular/common';
import { SDSColors } from '../../utils';
import { SafeHtml } from '@angular/platform-browser';
import { CustomSvgIcons } from '../../services';

@Component({
  selector: 'app-firmware-state-icon',
  templateUrl: './firmware-state-icon.component.html',
  styleUrls: ['./firmware-state-icon.component.scss'],
  imports: [TooltipComponent, TranslateModule, SafeHtmlPipe, CommonModule],
})
export class FirmwareStateIconComponent implements OnInit, OnChanges {
  @Input() firmwareState: FirmwareState = 'UNKNOWN';
  @Input() showLabel = true;

  color: string;
  icon: string | SafeHtml;
  label: string;
  labelColor: string;
  description: string;
  envFeatures = inject(ENVIRONMENT).envSpecificFeatures;

  constructor(private customIcons: CustomSvgIcons) {
    this.update();
  }

  ngOnInit(): void {
    this.update();
  }

  ngOnChanges(): void {
    this.update();
  }

  private update(): void {
    switch (this.firmwareState) {
      case 'CURRENT':
        this.icon = 'check';
        this.color = SDSColors.success;
        this.labelColor = SDSColors.success;
        break;
      case 'UPDATE_AVAILABLE':
        this.icon = this.customIcons.custom_firmware_update_available;
        this.color = SDSColors.primary;
        this.labelColor = SDSColors.primary;
        break;
      case 'UNKNOWN':
        this.icon = 'help';
        this.color = SDSColors.secondary;
        this.labelColor = SDSColors.secondaryDark;
    }
    this.label = `asset.firmware.state.${this.firmwareState}.displayLabel`;
    this.description = `asset.firmware.state.${this.firmwareState}.description`;
  }
}
